import DataTable, { DataTableProps } from './DataTable';

export type { DataTableProps };
export default DataTable;
